// Your JavaScript goes here
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {

    const scrollButtons = document.getElementsByClassName('scroll-to-contact-form')
    const scrollToProductsButtons = document.getElementsByClassName('scroll-to-products')

    if (scrollButtons) {
        for (let scrollButton of scrollButtons) {
            scrollButton.addEventListener('click', (e) => {
                e.preventDefault();
                // jQuery([document.documentElement, document.body]).animate({
                //     scrollTop: jQuery("#contact").offset().top
                // }, 2000);
                setTimeout(() => {
                    const contactForm = document.getElementById("contact");
                    const contactFormPosition = contactForm.getBoundingClientRect().top;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementPosition = contactFormPosition - bodyRect;
                    const headerOffset = 76;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }, 200)
            })
        }
    }

    if (scrollToProductsButtons) {
        for (let scrollToProductsButton of scrollToProductsButtons) {
            scrollToProductsButton.addEventListener('click', (e) => {
                e.preventDefault();
                // jQuery([document.documentElement, document.body]).animate({
                //     scrollTop: jQuery("#contact").offset().top
                // }, 2000);
                setTimeout(() => {
                    const productList = document.getElementById("products-list");
                    const productListPosition = productList.getBoundingClientRect().top;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementPosition = productListPosition - bodyRect;
                    const headerOffset = 76;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }, 200)
            })
        }
    }
});

